<template>
  <div class="diagnostic-company-data-view--container">
    <div>
      <div v-if="data.length <= 0">
        <div class="alert alert-sm alert-success">
          Проблем не обнаружено
        </div>
      </div>
      <div v-else>
        <div
            v-for="item in data"
            class="alert alert-sm mrg-t-15"
            :class="{'alert-danger': isError(item.error_code), 'alert-warning': isWarning(item.error_code)}"
        >
          {{item.error_text}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "DiagnosticCompanyDataView",
  components: {  },
  data() {
    return {

    };
  },
  props: {
    data: Array,
  },
  watch: {

  },
  computed: {

  },
  methods: {
    isError(errorCode) {
      const errorCodes = [-1, -2, -3, -4, -5, -7, -8, -10, -11];
      return errorCodes.includes(errorCode);
    },
    isWarning(errorCode) {
      const errorCodes = [-6, -9];
      return errorCodes.includes(errorCode);
    }
  }
};
</script>

<style scoped lang="less">

</style>
